(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/users/users.tpl.html', [
'<section class="users">',
'',
'  <browse class="col-md-4 roles aside" roles="users.roles" active-promise="users.activePromise"></browse>',
'',
'  <div class="col-md-8">',
'',
'    <input type="text" class="filter-table form-control pull-right" ng-model="users.q" placeholder="{{\'role.filter_users\' | translate}}"></input>',
'    <i class="glyphicon glyphicon-remove-sign filter-table-reset" ng-show="users.q != \'\'" ng-click="users.q = \'\'"></i>',
'    <h3 ng-if="!users.activeRole" class="roles-title">',
'      <ng-pluralize count="(users.users | filter: users.q | filter:users.selectionFilter).length"',
'                    when="{\'0\': \'{{ &quot;role.users_none&quot; | translate }}\',',
'                           \'1\': \'{} {{ &quot;role.user&quot; | translate }}\',',
'                           \'other\': \'{} {{ &quot;role.users&quot; | translate }}\'}">',
'    </h3>',
'    <h3 ng-if="users.activeRole" class="roles-title">',
'      {{(\'users.\'+users.activeRole.cn | translate).replace(\'users.\', \'\')}}',
'    </h3>',
'    <p ng-if="users.activeRole">',
'      <em class="content-description">{{users.activeRole.description | translate}}</em>',
'    </p>',
'',
'    <table class="table table-striped table-condensed">',
'',
'      <thead>',
'        <tr>',
'          <th>',
'            <div class="btn-group users-selection">',
'              <button type="button" class="btn btn-primary" ng-if="users.selection.length>0">',
'                {{users.selection.length}}',
'              </button>',
'              <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">',
'                <span class="caret"></span>',
'              </button>',
'              <ul class="dropdown-menu">',
'                <li><a href="javascript:void(0)" ng-click="users.select(\'none\')" translate>sel.none</a></li>',
'                <li><a href="javascript:void(0)" ng-click="users.select(\'all\')" translate>sel.all</a></li>',
'                <li role="separator" class="divider" ng-show="users.selection.length !== 0"></li>',
'                <li><a href="javascript:void(0)" ng-click="users.exportCSV()" ng-show="users.selection.length !== 0" translate>sel.export_csv</a></li>',
'                <li><a href="javascript:void(0)" ng-click="users.exportVCF()" ng-show="users.selection.length !== 0" translate>sel.export_vcard</a></li>',
'              </ul>',
'            </div>',
'          </th>',
'          <th translate>users.user</th>',
'          <th translate>users.login</th>',
'          <th translate>users.organization</th>',
'          <th translate>users.email</th>',
'        </tr>',
'      </thead>',
'',
'      <tbody>',
'        <tr dir-paginate="user in users.users | filter:users.q | filter:users.selectionFilter | itemsPerPage: users.itemsPerPage | orderBy : \'sn\' | filter: {pending: users.activeRole.cn===\'PENDING\'}">',
'          <td class="users-checkboxes">',
'            <input type="checkbox" ng-click="users.toggleSelected(user.uid)" ng-checked="users.selection.indexOf(user.uid)>=0">',
'          </td>',
'          <td>',
'            <a ng-link="user({id: user.uid, tab: \'infos\'})">{{::user.sn}} {{::user.givenName}}</a>',
'          </td>',
'          <td>{{::user.uid}}</td>',
'          <td>',
'            <a ng-link="org({org: user.orgId, tab: \'infos\'})">{{::user.org}}</a>',
'          </td>',
'          <td>{{::user.mail}}</td>',
'        </tr>',
'      </tbody>',
'',
'    </table>',
'',
'    <label class="pull-right checkbox">',
'      <input type="checkbox" ng-model="users.filterSelected"></input>',
'      <span translate>users.filter_selected</span>',
'    </label>',
'    <dir-pagination-controls></dir-pagination-controls>',
'',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();